import Toast from "../components/toast";

function defaultExceptionHandler(exception: unknown): void {
  if (exception instanceof Error) {
    Toast.error(exception.message);
    return;
  }

  console.error(exception);
  Toast.error("Ocorreu um erro inesperado");
}

export default {
  defaultExceptionHandler
};
